/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Websiteoptional1Inputs */

const en_websiteoptional1 = /** @type {(inputs: Websiteoptional1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website (Optional)`)
};

const de_websiteoptional1 = /** @type {(inputs: Websiteoptional1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webseite (optional)`)
};

/**
* | output |
* | --- |
* | "Website (Optional)" |
*
* @param {Websiteoptional1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const websiteoptional1 = /** @type {((inputs?: Websiteoptional1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Websiteoptional1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_websiteoptional1(inputs)
	return de_websiteoptional1(inputs)
});
export { websiteoptional1 as "websiteOptional" }